import React from 'react';
import { Link } from 'react-router-dom';

const FALLBACK_IMG = 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=800&auto=format&fit=crop';

export default function EventoCard({ evento, closed = false }) {
  const data = evento.data_evento ? new Date(evento.data_evento) : null;
  const dia = data ? data.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit' }) : '';
  const mes = data ? data.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo', month: 'short' }).replace('.', '') : '';
  const semLoteAberto = evento.preco === null || evento.preco === undefined || evento.preco === '';
  const emBreve = !closed && semLoteAberto;

  return (
    <div className="glass-card rounded-2xl shadow-sm border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden flex flex-col group">
      <div className="h-52 bg-gray-200 relative overflow-hidden">
        <img
          src={evento.imagem_url || FALLBACK_IMG}
          alt={evento.titulo}
          width={800}
          height={400}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {data && (
          <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-lg text-sm font-bold text-gray-800 shadow-sm flex items-center gap-2">
            <i className="far fa-calendar-alt text-primary-600"></i> {dia} {mes}
          </div>
        )}
        {closed && (
          <div className="absolute top-4 left-4 bg-gray-800/90 text-white px-3 py-1.5 rounded-lg text-xs font-bold shadow-sm">
            Encerrado
          </div>
        )}
      </div>
      <div className="p-6 flex-grow flex flex-col">
        <h3 className="text-xl font-bold text-gray-900 mb-2 leading-tight">{evento.titulo}</h3>
        <p className="text-gray-500 text-sm mb-6 line-clamp-2">{evento.descricao}</p>

        <div className="mt-auto pt-5 border-t border-gray-100 flex items-center justify-between gap-3">
          <div className="flex flex-col">
            <span className="text-[11px] text-gray-400 font-medium uppercase tracking-wider">Investimento</span>
            {emBreve ? (
              <span className="text-sm font-bold text-gray-400">Em Breve</span>
            ) : semLoteAberto ? (
              <span className="text-sm font-bold text-red-500">Esgotado</span>
            ) : Number(evento.preco) === 0 ? (
              <span className="text-sm font-bold text-green-600">Gratuito</span>
            ) : (
              <span className="text-base font-bold text-gray-800">
                {Number(evento.preco).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              </span>
            )}
          </div>
          {closed ? (
            <Link
              to={`/eventos/${evento.slug}`}
              className="bg-gray-100 hover:bg-gray-200 text-gray-600 px-5 py-2.5 rounded-lg text-sm font-semibold transition-colors"
            >
              Ver Evento
            </Link>
          ) : emBreve ? (
            <button disabled className="bg-gray-100 text-gray-400 px-5 py-2.5 rounded-lg text-sm font-semibold cursor-not-allowed">
              Em Breve
            </button>
          ) : (
            <Link
              to={`/eventos/${evento.slug}`}
              className="bg-primary-600 hover:bg-primary-700 text-white px-5 py-2.5 rounded-lg text-sm font-semibold transition-colors"
            >
              Inscrever-se
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
